//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import RbProductTileImagesCarousel from '@/elements/product-tile/product-tile-images-content/product-tile-images-carousel/rb-product-tile-images-carousel.vue'
import { MOBILE, TABLET } from '@/scripts/constants/media-query'
import RbProductTileUtils from '@/elements/product-tile/rb-product-tile'
import Images from '@/scripts/libs/images'
export default {
  name: 'product-tile-images-content',
  inject: ['isProductTileEditorial', 'isLoading', 'isPlpExclusive'],
  components: {
    RbProductTileImagesCarousel,
  },
  props: {
    colors: {
      type: Array,
      default: () => [],
    },
    selectedIndex: {
      type: Number,
      default: 0,
    },
    wornImage: {
      type: String,
      default: '',
    },
    showHoverImage: {
      type: Boolean,
      default: false,
    },
    preventLazy: {
      type: Boolean,
      default: false,
    },
    isFirstTransitionInViewport: {
      type: Boolean,
      default: false,
    },
    isInsideSearchPanel: {
      type: Boolean,
      default: false,
    },
    firstHover: {
      type: Boolean,
      default: false,
    },
    wornImagePosition: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      innerSelectedIndex: 0,
      isFirstShow: false,
    }
  },
  computed: {
    isMobile() {
      return [MOBILE, TABLET].includes(this.$mq)
    },
    transitionImageSrc() {
      return Images.getClusterTileImage({
        mediaQuery: this.$mq,
        productImage:
          this.isMobile || this.isPlpExclusive
            ? this.transitionHoverImage.mobile
            : this.transitionHoverImage.desktop,
        productType: this.category,
      })
    },
    isTransitionImage() {
      return (
        this.transitionHoverImage?.mobile &&
        this.transitionHoverImage?.desktop &&
        this.currentSelectValue?.isTransition
      )
    },
    currentSelectValue() {
      return this.colors[this.selectedIndex]
    },
    attachments() {
      return RbProductTileUtils.mapAttachmentsExclusive(this.currentSelectValue?.attachments) || []
    },
    swiperImages() {
      return (this.isPlpExclusive ? this.attachments : this.colors) || []
    },
    altImage() {
      return this.currentSelectValue?.imageAltText || ''
    },
    mainImage() {
      if (this.wornImage) {
        return this.currentSelectValue?.images?.primary
      }
      return Images.getClusterTileImage({
        mediaQuery: this.$mq,
        productImage: this.currentSelectValue?.images?.primary,
        productType: this.category,
      })
    },
    transitionHoverImage() {
      return RbProductTileUtils.getTransitionImages(this.currentSelectValue)
    },
    hoverImage() {
      if (this.wornImage && this.wornImagePosition !== 1) {
        return this.currentSelectValue?.images?.secondary
      }
      return Images.getClusterTileImage({
        mediaQuery: this.$mq,
        productImage: this.currentSelectValue?.images?.secondary,
        productType: this.category,
      })
    },
  },
  watch: {
    showHoverImage(nValue) {
      if (nValue && !this.isFirstShow) {
        this.isFirstShow = true
      }
    },
  },
  methods: {
    selectIndex(i) {
      if (!this.isPlpExclusive) {
        this.innerSelectedIndex = i
        this.$emit('update:select-index', i)
      }
    },
  },
}
